const ApplicationName = 'Mobility'
const ApplicationNameForMobilityServices = 'Mobility Services'

const Links = Object.freeze({
  helpLink: 'Help Link',
  breadcrumbName: 'Breadcrumb Billing Number',
  searchIconSharedFairPlayPageClick: 'Search Icon Button-Clicked',
  searchResultsSharedFairplayPage: 'Shared Fairplay Page',
  informationHove: 'Information Hover',
  loadOffersPage: 'MDUM Offer Page Load',
  offerPageTablePagination: 'Offer Page Pagination',
  offerDetailsLegacyPageTablePagination: 'Offer Details Legacy Page Pagination',
  offerPageTableSortDom: 'Offer Page Sort Domestic',
  offerPageTableSortInt: 'Offer Page Sort International',
  offerPageErrorTable: 'Offer Page Retry Table',
  offerDetailsLegacyPageErrorTable: 'Offer Details Legacy Page Retry Table',
  offerPageErrorUsage: 'Offer Page Retry Usage Summary',
  offerPageErrorBoth: 'Offer Page Retry Both',
  offerPageBreadcrumbMonitoring: 'Breadcrumb Monitoring and Performance',
  offerPageBreadcrumbDashboard: 'Breadcrumb Dashboard',
  offerDetailsLegacyPage: 'MDUM Offer Details Legacy Page Load',
  serviceChanges: 'Service changes',
  serviceUsage: 'Service usage',
  mobilityService: 'Mobility services',
  offerItemClick: 'Offer line item click',
  trackRequest: 'track service requests',
  searchEnterEventLink: `Find in Table-Pressed Enter.`,
  backToPreviousPage: 'Back button-Clicked',
  trackRequestButton: 'track request button--Clicked',
  planType: (userStack: string) => `${userStack}`,
  directoryListingTryAgain: 'Try again for Directory listing-Clicked',
  searchIconEventLink: `Find in Table-search icon-clicked.`,
})

const Components = Object.freeze({
  mdumListPageLoad: 'Loads MDUM List Page',
  mdumDetailsPageLoad: 'Loads MDUM Shared fairplay Page',
  mdumSharedFairplayPageSearchClick: 'MDUM Shared fairplay Page',
  mdumSearchResultsSharedFairplayPageLoad: 'Search results Load',
  mdumOffersPage: 'MDUM Offers Page',
  mdumOfferDetailsLegacyPage: 'Legacy Offer Details Page',
  ypsLandingPageComponent: 'YPS page: ',
  configurationSettingPage: 'Mobility Web Configuration Settings page',
  mobileServiceDetailPage: `Mobile Service Detail Page`,
  idd: (btnName: string) => `${btnName} button of International Calls-Clicked`,
  createRequestButtonForIDD: (pageName: string) =>
    `Create a request button in IDD to go to ${pageName}-Clicked`,
  anotherChangeCreateRequestButton: `Create request button to make another change-Clicked`,
  callStatusCreateButton: (webFormName: string) => `${webFormName} create a request button-Clicked`,
  confirmModifyDiversion: 'Confirm call forwarding-Clicked',
  saveButtonForCallForwarding: `Connection status block save button-Clicked`,
  manageButton: `Connection status block manage button-Clicked `,
  cancelConnectionStatusChange: `Connection status block cancel button-Clicked`,
  nextButtonForConnectionStatusChange: `Connection status block next button-Clicked`,
  modifyDiversionButtonClick: (action?: string) =>
    `${
      action
        ? 'Modify diversion form button-Clicked'
        : 'Modify diversion form go back button-Clicked'
    }`,
  connectionStatusRefresh: `Connection status change refresh button-Clicked`,
  intRoamDisableModal: `Disabling International Roaming Modal`,
  submitButtonForDisableIntRoamRequest: `Submit Button-Clicked`,
  intRoamEnableModal: `Enabling International Roaming Modal`,
  navigateToCustomerterms: `Customer terms link-Clicked`,
  navigateToEligibleCountries: `Eligible countries link-Clicked`,
  cancelButton: `Cancel button-Clicked`,
  submitButtonForEnableIntRoamRequest: (requestType: string) =>
    `Submit Button to raise ${requestType}-Clicked`,
  createRequestButtonClick: (blockName: string) => `${blockName} Create a request button-Clicked.`,
  toggleButtonForIntRoam: (actionName: string) =>
    `International roaming ${actionName} button-Clicked`,
  mobileServiceDetailsIntRoamShowDetailsLink: (buttonName) =>
    `International roaming ${buttonName} button-Clicked `,
  mobileServiceDetailsIntRoamLearnMoreLink: 'International roaming Learn more-Clicked',
  cancelLeavingTconnectModal: 'Leaving tconnect modal popup cancel button-Clicked',
  continueLeavingTconnectModal: 'Leaving tconnect modal popup continue button-Clicked',
  submitButtonForEnableMMSRequest: (requestType: string) =>
    `Submit Button to raise ${requestType}-Clicked`,
  mmsEnableModal: `Enabling MMS Modal`,
  mms: (btnName: string) => `MMS ${btnName} button-Clicked`,
  apn: (btnName: string) => `APN ${btnName} button-Clicked`,
  simSerialActionButton: (buttonName: string) => `Sim serial ${buttonName} button-Clicked`,
  pukCode: (btnName: string) => `PUK code ${btnName} button-Clicked`,
  mobilePlansAndDevicesMaximPage: 'Mobile plans and devices for maxim',
  mobileServiceListPage: 'mobile services: ',
  breadCrumbforMobilePlansAndDevicesMaxim:
    'Your products and services breadcrumb for maxim page-Clicked',
  mobileServiceChangeRequestForm: 'Mobile service change request form',
  ypsBreadCrumbformobileServiceChangeRequestForm: (formName: string) =>
    `Your products and services from ${formName} request form-Clicked`,
  mobilitySolutionFromGeneralForm: (formName: string) =>
    `Mobility solutions from ${formName} request form-Clicked`,
  mobServiceBreadCrumbforServiceDetailPage: `Mobile service List from detail page-Clicked`,
  ypsLandingPage: 'Your products and services landing page',
  ypsBreadCrumbforServiceDetailPage: `From  detail page-Clicked`,
  webForm: (webformName: string) => `${webformName} form`,
  dashboardBreadCrumbforWebForm: `Dashboard from breadcrumb-Clicked`,
  ypsBreadCrumbforWebForm: `YPS from breadcrumb-Clicked`,
  mobileServiceBreadCrumbforWebForm: `Mobile Service list from breadcrumb-Clicked`,
  serviceDetailBreadCrumbforWebForm: `Service Detail page from breadcrumb-Clicked`,
  messageBankEnableModal: `Enabling MessageBank Modal`,
  voicemail: (btnName: string) => `Voicemail ${btnName} button-Clicked`,
  mobileServiceDetailsPromptActionButton: (buttonName: string) =>
    `Navigation prompt ${buttonName} button -Clicked`,
  maximSerivceRequestResponsePage: 'Maxim Service Request Submission Response Page',
  maximCreateNewRequestButton: 'Submit button-Clicked',
  submittedformName: (formName) => `${formName}: `,
  subFormNameWithRequestStatus: (subFormName: string, status: string) =>
    `Submission ${status} for ${subFormName}`,
  billingAccountRoute: `Billing account hyperlink-Clicked`,
  offerServiceListPage: `Service usage page`,
  serviceUsageAndConfigTabs: (tabName: string) => `${tabName} tab`,
  legacyETC: (btnName: string) => `Legacy ETC ${btnName} button-Clicked`,
})

export {ApplicationName, ApplicationNameForMobilityServices, Links, Components}
